var map = {
	"./en/about.json": 4048,
	"./en/base.json": 6146,
	"./en/culture.json": 4971,
	"./en/donate.json": 5944,
	"./en/faq.json": 7925,
	"./en/footer.json": 7184,
	"./en/hero.json": 8247,
	"./en/quotes.json": 8182,
	"./ua/about.json": 4841,
	"./ua/base.json": 9505,
	"./ua/culture.json": 3550,
	"./ua/donate.json": 6463,
	"./ua/faq.json": 2496,
	"./ua/footer.json": 5027,
	"./ua/hero.json": 792,
	"./ua/quotes.json": 7081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7189;